var _defs, _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAndroidStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "google-play-badge-logo-svgrepo-com",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 215.522,
    height: 63.858,
    viewBox: "0 0 215.522 63.858",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.908,
    y1: 1.032,
    x2: -0.383,
    y2: 0.36,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#00a1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00beff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00d2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00dfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00e3ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1.077,
    y1: 0.729,
    x2: -1.307,
    y2: 0.729,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#ffbd00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9c00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.864,
    y1: -0.023,
    x2: -0.499,
    y2: -1.789,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3a44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -0.186,
    y1: 2.701,
    x2: 0.423,
    y2: 1.909,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32a071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    stopColor: "#2da771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#15cf74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#06e775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f076"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1730",
    "data-name": "Path 1730",
    d: "M207.539,63.858H7.982A7.9,7.9,0,0,1,0,55.876V7.982A7.9,7.9,0,0,1,7.982,0H207.539a7.9,7.9,0,0,1,7.982,7.982V55.876A7.9,7.9,0,0,1,207.539,63.858Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1732",
    "data-name": "Path 1732",
    d: "M50.979,12.168a4.348,4.348,0,0,1-1.118,3.193,5.011,5.011,0,0,1-7.024,0A4.694,4.694,0,0,1,41.4,11.849a4.694,4.694,0,0,1,1.437-3.512A4.694,4.694,0,0,1,46.349,6.9a4.251,4.251,0,0,1,1.916.479A3.476,3.476,0,0,1,49.7,8.5l-.8.8a2.977,2.977,0,0,0-2.554-1.118,3.176,3.176,0,0,0-2.554,1.118,3.289,3.289,0,0,0-1.118,2.714,3.289,3.289,0,0,0,1.118,2.714,4.111,4.111,0,0,0,2.554,1.118,3.5,3.5,0,0,0,2.714-1.118,2.644,2.644,0,0,0,.8-1.916H46.349V11.53h4.63v.639Zm7.344-3.991h-4.31V11.21H58v1.118H54.012v3.033h4.31v1.277H52.735V7.06h5.588Zm5.268,8.461H62.314V8.177H59.6V7.06H66.3V8.177H63.591Zm7.344,0V7.06h1.277v9.579Zm6.705,0H76.362V8.177H73.648V7.06h6.545V8.177H77.48v8.461Zm15.166-1.277a5.011,5.011,0,0,1-7.024,0,4.694,4.694,0,0,1-1.437-3.512,4.694,4.694,0,0,1,1.437-3.512,5.011,5.011,0,0,1,7.024,0,4.694,4.694,0,0,1,1.437,3.512A4.694,4.694,0,0,1,92.806,15.361Zm-6.067-.8a3.767,3.767,0,0,0,2.554,1.118,3.176,3.176,0,0,0,2.554-1.118,3.851,3.851,0,0,0,1.118-2.714,3.289,3.289,0,0,0-1.118-2.714,3.767,3.767,0,0,0-2.554-1.118,3.176,3.176,0,0,0-2.554,1.118,3.851,3.851,0,0,0-1.118,2.714A3.289,3.289,0,0,0,86.739,14.563ZM96,16.638V7.06h1.437l4.63,7.5V7.06h1.277v9.579h-1.277L97.116,8.816v7.823H96Z",
    transform: "translate(24.693 4.116)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1733",
    "data-name": "Path 1733",
    d: "M84.2,24.6a6.716,6.716,0,0,0-6.865,6.865A6.814,6.814,0,0,0,84.2,38.333a6.716,6.716,0,0,0,6.865-6.865A6.623,6.623,0,0,0,84.2,24.6Zm0,10.856a3.963,3.963,0,0,1-3.832-4.151A3.963,3.963,0,0,1,84.2,27.158a3.867,3.867,0,0,1,3.831,4.151A3.963,3.963,0,0,1,84.2,35.459ZM69.357,24.6a6.716,6.716,0,0,0-6.865,6.865,6.814,6.814,0,0,0,6.865,6.865,6.716,6.716,0,0,0,6.865-6.865A6.623,6.623,0,0,0,69.357,24.6Zm0,10.856a3.963,3.963,0,0,1-3.832-4.151,3.963,3.963,0,0,1,3.832-4.151,3.867,3.867,0,0,1,3.831,4.151A3.963,3.963,0,0,1,69.357,35.459ZM51.637,26.679v2.874H58.5a6.037,6.037,0,0,1-1.6,3.672A7.066,7.066,0,0,1,51.637,35.3a7.433,7.433,0,0,1-7.5-7.663,7.531,7.531,0,0,1,7.5-7.663A7.916,7.916,0,0,1,56.9,22.049l2.075-2.075A10.23,10.23,0,0,0,51.8,17.1,10.769,10.769,0,0,0,41.1,27.637,10.769,10.769,0,0,0,51.8,38.173,9.188,9.188,0,0,0,59.14,35.14a9.611,9.611,0,0,0,2.554-6.705,5.986,5.986,0,0,0-.16-1.756h-9.9Zm72.479,2.235a6.2,6.2,0,0,0-5.747-4.31c-3.512,0-6.386,2.714-6.386,6.865a6.681,6.681,0,0,0,6.705,6.865,6.549,6.549,0,0,0,5.588-3.033l-2.235-1.6a3.891,3.891,0,0,1-3.353,1.916,3.464,3.464,0,0,1-3.353-2.075l9.1-3.831-.319-.8Zm-9.259,2.235a3.878,3.878,0,0,1,3.512-3.991,2.824,2.824,0,0,1,2.554,1.437l-6.067,2.554Zm-7.5,6.545h3.033V17.739h-3.033ZM102.564,26.04a5.256,5.256,0,0,0-3.672-1.6,6.86,6.86,0,0,0-6.545,6.865,6.61,6.61,0,0,0,6.545,6.705,4.584,4.584,0,0,0,3.512-1.6h.16v.958c0,2.554-1.437,3.991-3.672,3.991a3.547,3.547,0,0,1-3.353-2.395l-2.554,1.118a6.586,6.586,0,0,0,6.067,3.991c3.512,0,6.386-2.075,6.386-7.024V24.923h-2.874V26.04Zm-3.512,9.419a3.963,3.963,0,0,1-3.832-4.151,3.963,3.963,0,0,1,3.832-4.151c2.075,0,3.672,1.756,3.672,4.151S101.127,35.459,99.051,35.459ZM138,17.739h-7.184V37.694h3.033v-7.5H138a6.234,6.234,0,1,0,0-12.452Zm.16,9.579h-4.31V20.453h4.31a3.507,3.507,0,0,1,3.512,3.353,3.654,3.654,0,0,1-3.512,3.512Zm18.359-2.874c-2.235,0-4.47.958-5.268,3.033l2.714,1.118a2.82,2.82,0,0,1,2.714-1.437,3,3,0,0,1,3.193,2.554v.16a6.332,6.332,0,0,0-3.033-.8c-2.874,0-5.747,1.6-5.747,4.47a4.677,4.677,0,0,0,4.949,4.47,4.493,4.493,0,0,0,3.831-1.916h.16v1.6h2.874V30.031A6.042,6.042,0,0,0,156.524,24.444ZM156.2,35.459c-.958,0-2.395-.479-2.395-1.756,0-1.6,1.756-2.075,3.193-2.075a6.174,6.174,0,0,1,2.714.639A3.718,3.718,0,0,1,156.2,35.459Zm16.763-10.537-3.353,8.621h-.16l-3.512-8.621H162.75l5.268,12.133-3.033,6.705h3.033l8.142-18.838Zm-26.82,12.772h3.033V17.739h-3.033Z",
    transform: "translate(24.514 10.199)",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_369",
    "data-name": "Group 369",
    transform: "translate(15.965 11.41)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1734",
    "data-name": "Path 1734",
    d: "M10.639,7.5A3.121,3.121,0,0,0,10,9.735V45.017a3.158,3.158,0,0,0,.8,2.235l.16.16,19.8-19.8V27.3Z",
    transform: "translate(-10 -6.937)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1735",
    "data-name": "Path 1735",
    d: "M29.445,29.37,22.9,22.824v-.479L29.445,15.8l.16.16,7.823,4.47c2.235,1.277,2.235,3.353,0,4.63Z",
    transform: "translate(-2.306 -1.986)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1736",
    "data-name": "Path 1736",
    d: "M37.061,26.705,30.356,20,10.4,39.956c.8.8,1.916.8,3.353.16l23.308-13.41",
    transform: "translate(-9.761 0.519)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1737",
    "data-name": "Path 1737",
    d: "M37.061,20.947,13.753,7.7c-1.437-.8-2.554-.639-3.353.16l19.956,19.8,6.705-6.705Z",
    transform: "translate(-9.761 -7.133)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1738",
    "data-name": "Path 1738",
    d: "M36.9,24.1,13.753,37.191a2.611,2.611,0,0,1-3.193,0l-.16.16.16.16a2.611,2.611,0,0,0,3.193,0Z",
    transform: "translate(-9.761 2.964)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1739",
    "data-name": "Path 1739",
    d: "M10.639,39.636A3.121,3.121,0,0,1,10,37.4v.16a3.158,3.158,0,0,0,.8,2.235v-.16h-.16ZM45.122,22.075l-7.982,4.47.16.16,7.823-4.47A2.654,2.654,0,0,0,46.718,20C46.718,20.8,46.08,21.437,45.122,22.075Z",
    transform: "translate(-10 0.519)",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1740",
    "data-name": "Path 1740",
    d: "M13.991,7.87,45.122,25.591c.958.639,1.6,1.277,1.6,2.075a2.654,2.654,0,0,0-1.6-2.235L13.991,7.71C11.756,6.433,10,7.391,10,9.945v.16C10,7.71,11.756,6.593,13.991,7.87Z",
    transform: "translate(-10 -7.147)",
    fill: "#fff",
    opacity: 0.25
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroidStore);
export default __webpack_public_path__ + "static/media/androidStore.b5458ab13c695a73d4328c3d004d5d48.svg";
export { ForwardRef as ReactComponent };